APPS.course.earthScienceCoursePage = (function(e){
    var show = function(e){
	    console.log('Course page')
        APP.getView().showChildView('mainRegion', new pageView() )
			
		window.document.title = 'COURSE';
		if(typeof ga !== "undefined" ){ ga('send','pageview',{ page:"/", title:'COURSE' }) } 
		}
     
    /***********************************************************************
	 ***********************************************************************
	    VIEWS 
	 ***********************************************************************
	 ***********************************************************************/
        var pageView = Mn.View.extend({
			template: _.template($("#template_earth_science_course_page").html())
			,className:"page_course"
  	        , initialize: function(){
				//$('a.link[href="/ourpartners"]').addClass("active");
	        }
	        
	    })
	    
    return {
        show:show
    }
})();